import { Template, TemplatesResponse } from '../../types/api';

export const mapTemplatesToData = (templates: Template[] = []): String => {
  let data;
  try {
    data = JSON.stringify({
      templates: templates.map((template, i) => ({
        json_id: template.id,
        gallerydocindex: i,
        template_id: template.siteId,
      })),
    });
  } catch (e) {
    // TODO: Will be failed on server
    window && window.Sentry.captureException && window.Sentry.captureException(e);
  }

  return data;
};

export const mapTemplatesResponseToTemplateData = ({
  items,
  pagination: { current, pageSize, total },
}: TemplatesResponse): String => {
  let data;
  try {
    data = JSON.stringify({
      templates: items.map((template, i) => ({
        json_id: template.id,
        template_id: template.siteId,
        source: template.source,
        current_page: current,
        page_position: i,
        page_size: pageSize,
        total_pages: total,
        section: 1,
        score: template.score,
      })),
    });
  } catch (e) {
    window.Sentry.captureException && window.Sentry.captureException(e);
  }
  return data;
};
